import { render } from "./ExternalLinkSVG.vue?vue&type=template&id=abdd765c&scoped=true"
const script = {}

import "./ExternalLinkSVG.vue?vue&type=style&index=0&id=abdd765c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abdd765c"]])

export default __exports__